module.exports = __webpack_public_path__ + "media/images/lock-40ff66b6.png";